import {
  FETCH_MAINCATEGORY_LIST,
  FETCH_SUBCATEGORY_LIST,
  UPDATE_FEATUREEDIT_DATA,
  SET_FEATUREEDITMODALVISIBLE,
  SET_OPERATETYPE,
  SET_CONFIRMLOADING,
  GET_DOMAIN
} from "../actions/categoryModel";

const defVal = {
  stdDomainList: [],
  mainCategoryList: [],
  subCategoryList: [],
  // 是否显示
  featureEditModalVisible: false,
  // 操作类别 add 添加 edit 编辑
  operateType: 'add',
  // loading状态
  confirmLoading: false,
  // 编辑已添加功能点时使用
  sourceTrabsType: 1,
  id: 1,

  // 数据
  featureEditData: {
    id: 1,
    direction: "",
    did: "",
    // 功能点类型 "prop"-属性，"action"-操作，"event"-事件
    ftype: "prop",
    // 功能名称	
    name: '',
    // 功能名称(中文)	
    deNameCh: '',
    // 功能名称(英文)	
    deNameEn: '',
    //ptype为STD代表标准功能,CUSTOM为自定义功能
    ptype: "STD",
    // 识别符
    key: '',
    // 是否可选	0 必选 1 可选
    //"r"-只上报；w-只下发；rw"-上报下发
    access: "r",
    // 功能备注	
    remark: '',
    //schema
    schema: "",
    emphasis: 0,
    //响应
    output: "",
    //请求
    input: "",
    //事件类型
    eventType: "notification",
    etype: "",

    sort: 0,
    statusCode: "",
    tplPublishId: 0,
    tplPublishVersion: 0,
    version: "",
    publishVersion: 0,
    noPush: false,
    domainKey: "",
    resKey: "",
    resId: "",
  }
}

export default (state = defVal, action) => {
  switch (action.type) {
    case FETCH_MAINCATEGORY_LIST:
      return Object.assign({}, state, {
        mainCategoryList: action.mainCategoryList
      });

    case FETCH_SUBCATEGORY_LIST:
      return Object.assign({}, state, {
        subCategoryList: action.subCategoryList
      });
    case UPDATE_FEATUREEDIT_DATA:
      return Object.assign({}, state, {
        featureEditData: action.featureEditData,
      });
    case SET_FEATUREEDITMODALVISIBLE:
      return Object.assign({}, state, {
        featureEditModalVisible: action.featureEditModalVisible,
      });
    case SET_OPERATETYPE:
      return Object.assign({}, state, {
        operateType: action.operateType,
      });
    case SET_CONFIRMLOADING:
      return Object.assign({}, state, {
        confirmLoading: action.confirmLoading,
      });
    case GET_DOMAIN:
      return Object.assign({}, state, {
        stdDomainList: action.stdDomainList,
      });
    default:
      return state;
  }
}